import { render } from "./HomeVue.vue?vue&type=template&id=20ca9af5"
import script from "./HomeVue.vue?vue&type=script&lang=js"
export * from "./HomeVue.vue?vue&type=script&lang=js"

import "./HomeVue.vue?vue&type=style&index=0&id=20ca9af5&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__